module.exports = __webpack_public_path__ + "static/media/close-circle.2870b83a.svg";